/*
  Cobro del bordado "modo carrito" (02-oct-2026).
  Mientras la funcion de cobro (app myscrubs-bordado) no se pueda activar, el
  bordado se cobra como lo hacia Easify: con los productos ocultos de cargo como
  lineas aparte en el carro. Mismos productos y SKU => la boleta en Bsale sale igual.

  Cada prenda con bordado lleva la propiedad _bordado_id. Este script mira el carro
  y deja, por cada prenda, sus cargos (propiedad _bordado_de = ese id) con la misma
  cantidad que la prenda: los agrega si faltan, los ajusta si cambia la cantidad y
  los quita si la prenda se fue. El cliente no puede quedarse con el bordado sin pagarlo.

  OJO: cuando se active la funcion de cobro hay que APAGAR este modo (sacar el
  script de layout/theme.liquid), si no se cobraria dos veces.
*/
(function () {
  var C = {
    linea1: 50535528071490,
    linea2: 50535537639746,
    linea3: 50535537639746, // linea 3 = producto "Linea 2" (decision 02-oct: misma tarifa que la linea 2)
    logo: 50535560905026,
    matriz: 52940703596866,
    bolsillo: 50551931535682
  };
  var HANDLES = ['linea-1-1745254208931', 'linea-2-2010-1745254274406', 'logo-1745254553719', 'matriz-no-institucional', 'bosillo-utilizable-servicio-de-cosido'];
  var SECCIONES = 'cart-drawer,cart-icon-bubble';
  var ocupado = false, pendiente = false;

  // Las lineas de cargo no se pueden mover a mano: van atadas a la prenda.
  var css = HANDLES.map(function (h) {
    return 'tr:has(a[href*="/products/' + h + '"]) quantity-popover, tr:has(a[href*="/products/' + h + '"]) cart-remove-button, tr:has(a[href*="/products/' + h + '"]) .cart-item__quantity-wrapper';
  }).join(',') + '{visibility:hidden!important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function txt(v) { return typeof v === 'string' ? v.trim() : ''; }
  function cargosDe(p) {
    var out = [];
    if (txt(p['Linea 1'])) out.push(C.linea1);
    if (txt(p['Linea 2'])) out.push(C.linea2);
    if (txt(p['Linea 3'])) out.push(C.linea3);
    if (txt(p['Logo'])) out.push(C.logo);
    if (txt(p['Matriz'])) out.push(C.matriz);
    if (/^s[ií]/i.test(txt(p['Bolsillo'])) && txt(p['Ubicacion del bordado']) === 'Pecho Izquierdo') out.push(C.bolsillo);
    return out;
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  function pintar(res) {
    var d = document.querySelector('cart-drawer');
    if (res && res.sections && d && d.renderContents) {
      try { d.classList.remove('is-empty'); d.renderContents(res); return; } catch (e) {}
    }
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function sincronizar() {
    if (ocupado) { pendiente = true; return; }
    ocupado = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var prendas = {}, cargos = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p._bordado_id) prendas[p._bordado_id] = { qty: it.quantity, quiere: cargosDe(p) };
        if (p._bordado_de) (cargos[p._bordado_de] = cargos[p._bordado_de] || []).push(it);
      });
      var updates = {}, agregar = [];
      Object.keys(cargos).forEach(function (id) {
        var pr = prendas[id];
        var faltan = pr ? pr.quiere.slice() : [];
        cargos[id].forEach(function (it) {
          var i = faltan.indexOf(it.variant_id);
          if (i === -1) { updates[it.key] = 0; return; }
          faltan.splice(i, 1);
          if (it.quantity !== pr.qty) updates[it.key] = pr.qty;
        });
        if (pr) faltan.forEach(function (v) { agregar.push({ id: v, quantity: pr.qty, properties: { _bordado_de: id } }); });
      });
      Object.keys(prendas).forEach(function (id) {
        if (cargos[id]) return;
        prendas[id].quiere.forEach(function (v) { agregar.push({ id: v, quantity: prendas[id].qty, properties: { _bordado_de: id } }); });
      });
      var paso = Promise.resolve(null);
      if (Object.keys(updates).length) paso = paso.then(function () { return post('/cart/update.js', { updates: updates, sections: SECCIONES, sections_url: location.pathname }); });
      if (agregar.length) paso = paso.then(function () { return post('/cart/add.js', { items: agregar, sections: SECCIONES, sections_url: location.pathname }); });
      return paso.then(function (res) {
        if (!res) return;
        if (res.status && res.status >= 400) { console.warn('[bordado] no se pudo ajustar el carro', res); return; }
        if (res.items && !res.sections) return fetch('/?sections=' + SECCIONES).then(function (r) { return r.json(); }).then(function (s) { pintar({ sections: s }); });
        pintar(res);
      });
    }).catch(function (e) { console.warn('[bordado]', e); }).then(function () {
      ocupado = false;
      if (pendiente) { pendiente = false; setTimeout(sincronizar, 50); }
    });
  }

  function suscribir() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sincronizar, 60); });
    }
    sincronizar();
  }
  window.BordadoCarrito = { sincronizar: sincronizar };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suscribir); else suscribir();
})();
